<template>
  <nav
    class="navbar"
    :class="{ 'is-transparant': projectsunset, 'transparent-background': projectsunset, 'is-dark': projectsunset }"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <!-- @slot Left side, always visible -->
      <slot name="brand"></slot>
      <a
        role="button"
        class="navbar-burger burger"
        :class="{ 'has-text-light': projectsunset, 'badge': hasBadge }"
        aria-label="menu"
        @click="burgerClick"
        id="burger"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div
      class="navbar-menu"
      :class="{ 'transparent-background': projectsunset }"
      id="nav-menu"
    >
      <div class="navbar-start">
        <!-- @slot Left side, hidden on mobile -->
        <slot name="start"></slot>
      </div>
      <div class="navbar-end">
        <!-- @slot Right side, hidden on mobile -->
        <slot name="end"></slot>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** A top navbar */
export default defineComponent({
  props: {
    /** Set to true to make it dark and transparant */
    projectsunset: {
      type: Boolean,
      default: false,
    },
    /** Set to true to give the hamburger menu a red badge */
    hasBadge: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route() {
      document.getElementById("nav-menu").classList.remove("is-active")
      document.getElementById("burger").classList.remove("is-active")
    }
  },
  methods: {
    burgerClick() {
      document.getElementById("nav-menu").classList.toggle("is-active")
      document.getElementById("burger").classList.toggle("is-active")
    }
  }
})
</script>

<style scoped>
.transparent-background {
  background-color: transparent !important;
}

.badge::after {
  content: '';
  background-color: hsl(348, 100%, 61%);
  width: 10px;
  height: 10px;
  border-radius: 12px;
  position: relative;
  left: 30px;
  top: 5px;
  display: inline-block;
}
</style>